module.exports = __webpack_public_path__ + "static/sageknittedblanket-d16be204d92449c3b8cd688fb216512e.jpeg";